import EKGPreview from './EKGPreview'

export default EKGPreview



// WEBPACK FOOTER //
// ./src/legacy/components/EKGPreview/index.js